export default "__VITE_ASSET__KjFBSEp4__"